import { render } from "./MaintenacePage.vue?vue&type=template&id=dc25c38c&scoped=true"
import script from "./MaintenacePage.vue?vue&type=script&lang=js"
export * from "./MaintenacePage.vue?vue&type=script&lang=js"

import "./MaintenacePage.vue?vue&type=style&index=0&id=dc25c38c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc25c38c"]])

export default __exports__